import Vue from 'vue';
import Vuex from 'vuex';
import App from './App';
import router from './router';
import store from './store'; //状态管理器

import "./utils/network";
import "./utils/request";

import BootstrapVue from 'bootstrap-vue'

import './icons' // 字体图标

import 'normalize.css'; // 重置样式
import 'babel-polyfill'; //低版本兼容组件


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@/assets/css/global.css'; //自定义样式
import 'animate.css'

import {
  baseURL
} from '@/utils/request';

Vue.use(BootstrapVue);
Vue.use(Vuex);

Vue.config.productionTip = false;
Vue.prototype.$store = store;
Vue.prototype.$baseURL = baseURL;

const $em = new Vue({ //挂载
  router,
  store,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js